//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useEffect } from 'react';

// ### MUI / STYLES ###
import { useTheme } from '@mui/material/styles';

// === COMPONENTS ===
import { FileProvider } from '../FileContext/FileContext';
import { DropProvider } from 'components/DragDrop/DropContext';
import { Panel } from '../Panel';
import Styled from 'components/Styled/Styled';

// === HOOKS ===
import { useLayout } from '../Panel/PanelContext';

//#endregion

//-----------------------------------------------------------------
export function FileView() {
  //-----------------------------------------------------------------

  //#region [VALUES]
  
  const theme = useTheme();

  const { save } = useLayout();

  //#endregion

  //#region [EFFECT]

  useEffect( () => {
    // Save any changes to the local layout when leaving the page
    return () => {
      save();
    }
  }, [] );

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Styled styles={[{height: 'calc( 100% - 60px )'}, { padding: '12px', backgroundColor: theme.palette.background.secondary[theme.palette.mode] } ]}>
        <FileProvider>
          <DropProvider>
            <Panel id={1} />
          </DropProvider>
        </FileProvider>
      </Styled>
    )
  }

  //#endregion

  return display();
}